/* eslint-disable react/prop-types */
/* eslint-disable react/destructuring-assignment */
/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import React from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { routes } from "../utilities/routes";
import * as authActions from "../../store/auth/actions";
import Login from "./Login";
import qs from "qs";
import { getLSAuth } from "../utilities/utils";

class LoginContainer extends React.Component {
  constructor() {
    super();
    this.state = {
      email: null,
    };
    this.login = this.login.bind(this);
  }
  /* istanbul ignore next */
  componentDidMount() {
    const lsAuth = getLSAuth();
    if (!lsAuth.user_id) {
      this.props.ClearAuth();
    }
    window.datazoom && window.datazoom.generateEvent("page_hit");
  }

  /* istanbul ignore next */
  login(email, password) {
    /* istanbul ignore next */
    this.props.RequestLogin({ email, password });
    this.setState({ email: email });
  }
  /* istanbul ignore next */
  resetCurrentLoginData = () => {
    /* istanbul ignore next */
    this.props.ResetCurrentLoginData();
  };

  render() {
    /* istanbul ignore next */
    if (this.props.auth && this.props.auth.isLoggedIn) {
      window.datazoom &&
        window.datazoom.generateEvent("login", {
          userId: this.state.email,
          company: this.props.auth.user.companyname,
          success: this.props.auth.isLoggedIn,
        });
      const queryParams = qs.parse(this.props.location.search, {
        ignoreQueryPrefix: true,
      });
      if (queryParams.redirect && queryParams.redirect.includes("?")) {
        this.props.history.push(queryParams.redirect);
        return <div />;
      }
      /* istanbul ignore next */
      return (
        <Redirect
          to={{
            pathname:
              queryParams && queryParams.redirect
                ? queryParams.redirect
                : routes.dashboard,
            state: { from: this.props.location },
          }}
        />
      );
    } else {
      if (this.state.email !== null && this.props.auth.error !== null) {
        window.datazoom &&
          window.datazoom.generateEvent("login", {
            userId: this.state.email,
            success: this.props.auth.isLoggedIn,
          });
      }
    }

    return (
      <Login
        login={this.login}
        auth={this.props.auth}
        resetCurrentLoginData={this.resetCurrentLoginData}
      />
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state, ownProps) {
  return { auth: state.auth };
}
/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return bindActionCreators(authActions, dispatch);
}
export default connect(mapStateToProps, mapDispatchToProps)(LoginContainer);
